import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';

import Footer from './components/Footer';
import { appPropsAction } from './store/actions';
import withClearCache from './shared/hoc/withClearCache';
import { LayoutRoutes } from './shared/routes';
import setAPIBaseUrl from './utils/setAPIBaseUrl';
import { getItemFromStore } from './utils/utils';

setAPIBaseUrl();
function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    const user = getItemFromStore('user', {});
    if (user && user.token) dispatch(appPropsAction({ isAuthenticated: true }));
  }, [dispatch]);

  return (
    <Router basename={process.env.PUBLIC_URL}>
      <LayoutRoutes />
      <Footer />
    </Router>
  );
}

// export default App;
export default withClearCache(App);
